import cx from 'classnames';
import * as QRCode from 'qrcode';
import { useCallback, useEffect, useState } from 'react';

type Props = {
  data: any;
  className?: string;
  contentClassName?: string;
  imageClassName?: string;
  title?: string;
};

export const QrCode: React.FC<Props> = ({
  data,
  className,
  contentClassName,
  imageClassName,
  title,
}) => {
  const [qrCode, setQrCode] = useState<string>();
  const [loading, setLoading] = useState<boolean | null>(null);
  const [error, setError] = useState(false);

  const generateQrCode = useCallback(
    async (data: any) => {
      if (!loading && !error && !qrCode && data) {
        try {
          setLoading(true);
          const stringifiedData =
            typeof data === 'string' ? data : JSON.stringify(data);
          const qrCodeUrl = await QRCode.toDataURL(stringifiedData, {
            width: 512,
          });
          setQrCode(qrCodeUrl);
        } catch (e) {
          setError(!!e);
        } finally {
          setLoading(false);
        }
      }
    },
    [loading, error, qrCode],
  );

  useEffect(() => {
    generateQrCode(data);
  }, [data, generateQrCode]);

  if (loading !== false || error) {
    return null;
  }

  return (
    <div className={cx('tw-flex tw-flex-col tw-justify-center', className)}>
      <div
        className={cx(
          'tw-m-auto tw-mb-2 tw-border tw-px-2 tw-bg-white',
          contentClassName,
        )}
      >
        <img
          className={cx('tw-m-auto', imageClassName)}
          src={qrCode}
          alt="qr"
        />
        {title && (
          <div className="tw-text-center tw-font-bold tw-mb-4">{title}</div>
        )}
      </div>
    </div>
  );
};
